export default __webpack_public_path__ + "b3c40930178d135751c31d35fae2ae00.svg";